import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveKamUser } from '@app/shared/models/user';
import { UserService } from '@app/shared/services/api/user.service';
import { orderBy, trim } from 'lodash';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-user-delegate-dialog',
  templateUrl: './user-delegate-dialog.component.html',
  styleUrls: ['./user-delegate-dialog.component.scss'],
})
export class UserDelegateDialogComponent implements OnInit {
  kams: ActiveKamUser[] = [];
  filteredKams: Observable<any> = of();
  isLoading = false;
  newKamControl = new FormControl();
  selectedKam: any;

  constructor(private userService: UserService, public matDialogRef: MatDialogRef<UserDelegateDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.isLoading = true;

    this.userService.getActiveKamUsers().subscribe({
      next: (res) => {
        const data = res.filter((u) => u.guid !== this.data.selectedUserGuid);
        const sortedData = orderBy(data, ['displayName'], ['asc']);
        this.kams = sortedData;
        if (this.data.delegateEmail) {
          const prevDelegate = res.find((a) => a.email === this.data.delegateEmail);
          this.newKamControl.setValue(prevDelegate);
          this.selectedKam = prevDelegate;
        }
        this.filteredKams = this.newKamControl.valueChanges.pipe(
          startWith(''),
          map((searchText) => {
            if (trim(searchText).length <= 0) {
              this.selectedKam = null;
              return this.kams;
            }
            return this.kams.filter((u) => u.displayName.indexOf(searchText) >= 0);
          })
        );
        this.isLoading = false;
      },
      error: () => (this.isLoading = false),
    });
  }

  select(kam: any) {
    this.selectedKam = kam;
  }

  displayKam = (kam: any) => (kam ? kam.displayName : '');

  confirm() {
    this.matDialogRef.close(this.selectedKam);
  }

  cancel() {
    this.matDialogRef.close();
  }
}
